import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import { NavLink } from 'react-router-dom'
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import deepPurple from '@material-ui/core/colors/deepPurple';
import { Divider } from '@material-ui/core'
import { signOut } from '../../store/actions/authActions'
import { checkSA, checkA } from '../../constant'

const styles = {
  avatar: {
    margin: 10,
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
  },
  link: {
    textDecoration: 'none',
    color: deepPurple[500]
  },
  purpleAvatar: {
    margin: 10,
    color: '#fff',
    backgroundColor: deepPurple[500],
  },

};

const SignedInList = (props) => {
  const { firstName, lastName, initials, navigations, profile } = props;
  return (
    <div>
      <NavLink to='/' style={styles.link}>
        <ListItem button>
          <Avatar style={styles.purpleAvatar}>{initials}</Avatar>
          <ListItemText primary={`${firstName} ${lastName}`} />
        </ListItem>
      </NavLink>
      <Divider />

      <NavLink to='/' style={styles.link}>
        <ListItem button>
          <ListItemText primary="Dashboard" />
        </ListItem>
      </NavLink>

      {
        navigations && navigations.length ? navigations.map((navigation) => {
          return <NavLink to={navigation.path} key={navigation.path} style={styles.link}>
            <ListItem button>
              <ListItemText primary={navigation.title} />
            </ListItem>
          </NavLink>
        })
          : null
      }

      <Divider />
      <NavLink to='/' style={styles.link} >
        <ListItem button>
          <ListItemText primary="Log Out" onClick={props.signOut} />
        </ListItem>
      </NavLink>
    </div>
  )
}
const mapDispatchToProps = (disptach) => {
  return {
    signOut: () => disptach(signOut())
  }
}

export default connect(null, mapDispatchToProps)(SignedInList)